import { type App } from 'vue';
import { PageSection } from './page-section';
import { Breadcrumb } from './breadcrumb';
import { GeneralCard } from './general-card';
import { SearchTable } from './search-table';
import { RouterButton } from './router-button';
import { Modal } from '@arco-design/web-vue';
import { Upload } from './upload';
import { Image } from './image';
import { LoadingProvider } from './loading-provider';

export default {
  install(Vue: App) {
    Vue.component(PageSection.name as string, PageSection);
    Vue.component(Breadcrumb.name as string, Breadcrumb);
    Vue.component(GeneralCard.name as string, GeneralCard);
    Vue.component(SearchTable.name as string, SearchTable);
    Vue.component(RouterButton.name as string, RouterButton);
    Vue.component(Upload.name as string, Upload);
    Vue.component(Image.name as string, Image);
    Vue.component(LoadingProvider.name as string, LoadingProvider);

    Vue.use(Modal);
  },
};
